import {Timer} from '@gongxigames/framework/core';
import {GenericPopupEvents} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupEvents';
import {GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupType';
import {FreeSpinsModule} from '@gongxigames/framework/slot/modules/freespins/FreeSpinsModule';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

export class FreeSpinsInProgressState extends ModuleState<null, FreeSpinsModule> {
    protected _isNoWin = false;
    protected _waitPromise?: Promise<void>;
    protected _isOutroPopupShowed = false;
    protected canShowOutroPopupWinLimit = 0;
    protected actionNumberHandledByCanSpin = -1;

    public onEnterState(): void {
        this.actionNumberHandledByCanSpin = -1;
    }

    public onLeaveState(): void {

    }

    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.CAN_SPIN, this.onCanSpin.bind(this));
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted.bind(this));
        this.setEventHandler(ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped.bind(this));
        this.setEventHandler(FlowModuleEvents.FREESPINS_RETRIGGER_WIN, this.onRetrigger.bind(this));
        this.setEventHandler(FlowModuleEvents.FREE_SPINS_FINISHED, this.onFinished.bind(this));
        this.setEventHandler(FlowModuleEvents.NO_WIN, this.onNoWin.bind(this));
        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
    }

    protected onRetrigger(): void {
        this.module.gotoState(FreeSpinsModule.RETRIGGER_STATE);
    }

    protected onFinished(): void {
        if (!this._isOutroPopupShowed) {
            this._isOutroPopupShowed = true;

            if (this.canShowOutroPopup()) {
                const type = GenericPopupType.FREESPIN_OUTRO;

                this.emit(GenericPopupEvents.SHOW_POPUP, type, this.module.getValueByType(type));
            } else {
                this.emit(GenericPopupEvents.SHOW_POPUP, GenericPopupType.FREESPIN_OUTRO_NO_WIN);
            }

            this.module.gotoState(FreeSpinsModule.BASIC_STATE);
        }

        this._isNoWin = false;
    }

    protected onPopupClosed(): void {
        this._isOutroPopupShowed = false;
    }

    protected onCanSpin(): void {
        const actionNumber = this.module.logic.getActionNumber();

        if (this.actionNumberHandledByCanSpin === actionNumber) {
            return;
        }
        this.actionNumberHandledByCanSpin = actionNumber;

        if (this.module.logic.getFreeGamesCount() > 0) {
            if (this._waitPromise) {
                this._waitPromise.then(this.emitStartSpin.bind(this));
            } else {
                this.emitStartSpin();
            }
        } else {
            this.emit(FreeSpinsModule.FREESPINS_FINISHED);
        }
    }

    protected onAllReelsStopped(): void {
        this.actionNumberHandledByCanSpin = -1;
    }

    protected emitStartSpin(): void {
        if (this._isNoWin) {
            this.module.updateManager.add(new Timer(() => {
                this.emitFreeSpinStartSpin();
            }, 500, true));
        } else {
            this.emitFreeSpinStartSpin();
        }
    }

    protected emitFreeSpinStartSpin(): void {
        this.emit(FreeSpinsModule.FREESPIN_START_SPIN);

        this._waitPromise = new Promise<void>((resolve) => {
            this.module.updateManager.addTimer(() => {
                resolve();
                this._waitPromise = undefined;
            }, this.module.settings.get('roundDelay'), true);
        });
    }

    protected onSpinStarted(): void {
        this._isNoWin = false;
    }

    protected onNoWin(): void {
        this._isNoWin = true;
    }

    protected canShowOutroPopup(): boolean {
        const win = this.module.logic.getTotalWin();

        return win > this.module.logic.getTotalBet() * this.canShowOutroPopupWinLimit;
    }
}
